module.exports = ":host .event-status__text .event-status__name {\n  font-size: 0.9em;\n  font-weight: 700; }\n\n:host .event-status__text .event-status__label {\n  margin: 0.1em 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-components/event-status/event-current-status/event-current-status.presentation.scss
// module id = tDce
// module chunks = 12